import {
  createAsyncThunk,
  createSlice,
} from "@reduxjs/toolkit";
import { enqueueSnackbar } from "notistack"; // Assuming you are using notistack for notifications

import request from "../../utils/request";

const initialState = {
  isLoading: false,
  error: null,
  resume_page: 0,
  resumes: [],
  totalResumes: 0,
  interview_page: 0,
  interviews: {},
  totalInterviews: 0,
};

// Async thunk for fetching all resumes
export const getAllResumes = createAsyncThunk(
  "resultDashboard/getAllResumes",
  async (
    { page = 1, query = "", filter = {} },
    { getState, rejectWithValue }
  ) => {
    try {
      const state = getState();
      const company_id = state.auth?.user?.company_id;

      const response = await request({
        url: "/jobs/by-company",
        method: "POST",
        data: { company_id, skip: page, take: 20, query, ...filter },
      });

      console.log("RESPONSE", response, page);

      return {
        page,
        data: response?.data?.data || [],
        count: response?.data?.count || 0,
      };
    } catch (error) {
      enqueueSnackbar(error?.message, {
        autoHideDuration: 3000,
        variant: "error",
      });
      return rejectWithValue(error?.message);
    }
  }
);

// Async thunk for fetching all interviews
export const getAllInterivews = createAsyncThunk(
  "resultDashboard/getAllInterivews",
  async (
    { page = 1, query = "", filter = {} },
    { getState, rejectWithValue }
  ) => {
    try {
      const state = getState();
      const company_id = state.auth?.user?.company_id;

      const response = await request({
        url: "/interview/by-company",
        method: "POST",
        data: { company_id, skip: page, take: 20, query, ...filter },
      });

      console.log("RESPONSE INTERVIEWS GET", response, page);

      return {
        page,
        data: response?.data?.data || [],
        count: response?.data?.count || 0,
      };
    } catch (error) {
      enqueueSnackbar(error?.message, {
        autoHideDuration: 3000,
        variant: "error",
      });
      return rejectWithValue(error?.message);
    }
  }
);


// Slice
const resultDashboardSlice = createSlice({
  name: "resultDashboard",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getAllResumes.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getAllResumes.fulfilled, (state, action) => {
        state.isLoading = false;
        const { page, data, count } = action.payload;

        if (page === 1) {
          state.resumes = data
        } else if (data?.length > 0) {
          state.resumes = [...state.resumes, ...data]
        }

        state.totalResumes = count;
        state.resume_page = page;
      })
      .addCase(getAllResumes.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || action.error.message;
      })
      .addCase(getAllInterivews.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getAllInterivews.fulfilled, (state, action) => {
        state.isLoading = false;
        const { page, data, count } = action.payload;

        if (page === 1) {
          state.interviews = data
        } else if (data?.length > 0) {
          state.interviews = [...state.interviews, ...data]
        }
        state.totalInterviews = state.totalInterviews > 0 ? state.totalInterviews : count;
        state.interview_page = page;
      })
      .addCase(getAllInterivews.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || action.error.message;
      })
  },
});

// ACTION EXORT
// export const { clearPostCreationStates, editPostContent, clearPostFormData, updatePostFormData } = resultDashboardSlice.actions;

export const selectInterviewById = (state, id) => {
  return state.resultDashboard?.interviews?.find((ass) => ass?.id === id)
};
export const selectLoading = (state) => state.resultDashboard.isLoading;
export const selectError = (state) => state.resultDashboard.error;

export default resultDashboardSlice.reducer;
